export const translations = {
  it: {
    nav: {
      suite: "Suite maXimo",
      about: "La Struttura",
      rooms: "Annette Rooms",
      gallery: "Galleria",
      location: "Posizione",
      contact: "Contatti",
      book: "Prenota",
    },
    hero: {
      overline: "Bari Palese · Puglia",
      title: "Annette Rooms",
      subtitle: "Due strutture, un'unica ospitalità pugliese",
      description:
        "Camere eleganti e pulite, a due passi dall'aeroporto di Bari e dalla spiaggia di Palese. Un'ospitalità autentica, in una posizione privilegiata.",
      cta: "Prenota su WhatsApp",
      scroll: "Scorri per scoprire",
      badge1: "Suite con Vasca Idromassaggio e Camino privato",
    },
    suite: {
      overline: "In Evidenza · Featured",
      label: "Suite maXimo",
      title: "Vasca idromassaggio e camino privato a Bari Palese",
      lead: "La nostra suite più esclusiva: una casa vacanze intima con vasca idromassaggio privata, camino, ingresso indipendente e tutto il comfort per una fuga romantica in Puglia.",
      features: [
        { title: "Vasca idromassaggio", desc: "Idromassaggio privato in suite per un'esperienza di puro benessere." },
        { title: "Camino", desc: "Atmosfera calda e romantica grazie al camino interno." },
        { title: "Ingresso privato", desc: "Discrezione totale: accedi alla tua suite in autonomia." },
        { title: "Aria condizionata", desc: "Clima ideale in ogni stagione, con riscaldamento dedicato." },
      ],
      details: {
        type: "Casa Vacanze",
        beds: "1 letto",
        rooms: "2 ambienti",
        wifi: "WiFi gratuito",
      },
      cta: "Prenota la Suite su WhatsApp",
      seoNote: "Casa vacanze con idromassaggio e camino · Bari Palese · Puglia",
    },
    about: {
      overline: "La Struttura",
      title: "Ospitalità pugliese, autentica e curata",
      p1: "Annette Rooms è un B&B intimo nel cuore di Bari Palese, dove la luce mediterranea incontra l'eleganza contemporanea. Ogni camera è pensata come un rifugio privato: materiali naturali, linee pulite, dettagli curati.",
      p2: "Accanto al B&B, la nostra Suite maXimo è la proposta più esclusiva: una casa vacanze indipendente con vasca idromassaggio privata e camino, perfetta per una fuga romantica o un'occasione speciale. Due strutture, una stessa cura per l'ospitalità.",
      p3: "A pochi minuti a piedi dal mare, a un passo dall'aeroporto, e servito da metro e bus: la base perfetta per esplorare Bari, Polignano, Monopoli e Alberobello.",
      stat1: { n: "8.6", l: "Punteggio Booking" },
      stat2: { n: "143", l: "Recensioni" },
      stat3: { n: "13 min", l: "A piedi dal mare" },
    },
    rooms: {
      overline: "Le Camere",
      title: "Tre suite, una sola filosofia",
      description:
        "Ogni camera dispone di bagno privato, aria condizionata, WiFi gratuito, TV e asciugacapelli.",
      list: [
        {
          name: "Standard Double Room",
          bed: "1 letto king size",
          desc: "La nostra camera più essenziale. Un letto king, luce abbondante, atmosfera raccolta.",
        },
        {
          name: "Double Room",
          bed: "1 letto king + 1 letto singolo",
          desc: "Ideale per piccole famiglie o amici in viaggio. Spaziosa, luminosa, con bagno privato moderno.",
        },
        {
          name: "Double Room King",
          bed: "1 letto king size",
          desc: "Pareti in mattoni a vista e testiera decorata. Un tocco di carattere per una fuga romantica.",
        },
      ],
      cta: "Richiedi disponibilità",
    },
    gallery: {
      overline: "Galleria",
      title: "Uno sguardo ad Annette Rooms",
      description: "Le camere, i bagni, il mare di Palese. Clicca per ingrandire.",
    },
    amenities: {
      overline: "Servizi & Comfort",
      title: "Tutto quello che serve, niente di superfluo",
      items: [
        { title: "WiFi Gratuito", desc: "Connessione veloce in tutte le camere." },
        { title: "Aria Condizionata", desc: "Clima perfetto, in ogni stagione." },
        { title: "Bagno Privato", desc: "Doccia, asciugamani e cortesie incluse." },
        { title: "TV Flat-screen", desc: "Televisore in camera con canali nazionali." },
        { title: "Camere Non Fumatori", desc: "Ambiente pulito e salutare." },
        { title: "Check-in Privato", desc: "Ti aspettiamo con le chiavi in mano." },
        { title: "Minimarket", desc: "Prodotti essenziali sempre a portata." },
        { title: "Ingresso Privato", desc: "Discrezione e autonomia totale." },
      ],
    },
    location: {
      overline: "Posizione",
      title: "A un passo dal mare, a pochi minuti dall'aeroporto",
      description:
        "Bari Palese è un quartiere tranquillo e autentico, amato da chi cerca il contatto con il mare ma anche la comodità della città.",
      pins: [
        { label: "Aeroporto di Bari", value: "3 km" },
        { label: "Spiaggia di Palese", value: "13 min a piedi" },
        { label: "Stazione Metro", value: "3 min a piedi" },
        { label: "Centro di Bari", value: "11 km" },
        { label: "Cattedrale di Bari", value: "11 km" },
        { label: "Basilica San Nicola", value: "11 km" },
      ],
      address: "Via Domenico Renna 14, Bari Palese, 70128 Bari, Italia",
      directions: "Indicazioni stradali",
      openMap: "Apri in Google Maps",
    },
    reviews: {
      overline: "Recensioni",
      title: "Parlano i nostri ospiti",
      rating: "8.6 su 10 — Eccellente",
      count: "143 recensioni verificate",
      items: [
        {
          text: "Tutto perfetto! La camera era sempre pulita e accogliente dopo una lunga giornata a camminare. Posizione ottima, 5 minuti dalla spiaggia e circa 3 minuti dalla metro.",
          author: "Kristina",
          country: "Germania",
        },
        {
          text: "Struttura eccezionalmente pulita. Gli asciugamani erano cambiati ogni giorno, i pavimenti spazzati, perfino le nostre cose sistemate. Posizione ottima, vicino a stazione e aeroporto.",
          author: "Sylwia",
          country: "Polonia",
        },
        {
          text: "Camera nuova, pulita e moderna, di dimensioni ragionevoli e un buon bagno. Posizione eccellente per l'aeroporto e non lontano dal lungomare con ristoranti con vista.",
          author: "Ian",
          country: "Regno Unito",
        },
      ],
    },
    contact: {
      overline: "Contattaci",
      title: "Prenota la tua fuga in Puglia",
      description:
        "Scrivici direttamente su WhatsApp: ti risponderemo in tempo reale con disponibilità, tariffe e ogni dettaglio utile per il tuo soggiorno.",
      cta: "Apri WhatsApp",
      phone: "Telefono",
      email: "Email",
      address: "Indirizzo",
    },
    footer: {
      tagline: "B&B nel cuore di Bari Palese",
      rights: "Tutti i diritti riservati.",
      license: "Licenza",
    },
  },
  en: {
    nav: {
      suite: "Suite maXimo",
      about: "The Property",
      rooms: "Annette Rooms",
      gallery: "Gallery",
      location: "Location",
      contact: "Contact",
      book: "Book",
    },
    hero: {
      overline: "Bari Palese · Apulia",
      title: "Annette Rooms",
      subtitle: "Two properties, one Apulian hospitality",
      description:
        "Elegant, spotless rooms, a short walk from Palese Beach and close to Bari airport. Authentic hospitality in a privileged location.",
      cta: "Book on WhatsApp",
      scroll: "Scroll to explore",
      badge1: "Suite with Hot Tub & Private Fireplace",
    },
    suite: {
      overline: "Featured Property",
      label: "Suite maXimo",
      title: "Private hot tub and fireplace in Bari Palese",
      lead: "Our most exclusive suite: an intimate holiday home with private hot tub, fireplace, private entrance and every comfort for a romantic escape in Apulia.",
      features: [
        { title: "Hot Tub", desc: "Private hydromassage tub in-suite for pure wellness." },
        { title: "Fireplace", desc: "Warm, romantic atmosphere thanks to the indoor fireplace." },
        { title: "Private Entrance", desc: "Total discretion: access your suite independently." },
        { title: "Air Conditioning", desc: "Perfect climate any season, with dedicated heating." },
      ],
      details: {
        type: "Holiday Home",
        beds: "1 bed",
        rooms: "2 rooms",
        wifi: "Free WiFi",
      },
      cta: "Book the Suite on WhatsApp",
      seoNote: "Holiday home with hot tub & fireplace · Bari Palese · Apulia",
    },
    about: {
      overline: "The Property",
      title: "Authentic Apulian hospitality, refined and quiet",
      p1: "Annette Rooms is an intimate B&B in the heart of Bari Palese, where Mediterranean light meets contemporary elegance. Each room is designed as a private retreat: natural materials, clean lines, considered details.",
      p2: "A few minutes' walk from the sea, a stone's throw from the airport, and served by metro and bus: the perfect base to explore Bari, Polignano, Monopoli and Alberobello.",
      stat1: { n: "8.6", l: "Booking score" },
      stat2: { n: "143", l: "Reviews" },
      stat3: { n: "13 min", l: "Walk to beach" },
    },
    rooms: {
      overline: "The Rooms",
      title: "Three suites, one philosophy",
      description:
        "Every room has a private bathroom, air conditioning, free WiFi, TV and hairdryer.",
      list: [
        {
          name: "Standard Double Room",
          bed: "1 king bed",
          desc: "Our most essential room. A king bed, generous light, a quiet mood.",
        },
        {
          name: "Double Room",
          bed: "1 king + 1 single bed",
          desc: "Ideal for small families or friends. Spacious, bright, with a modern private bathroom.",
        },
        {
          name: "Double Room King",
          bed: "1 king bed",
          desc: "Exposed brick walls and a decorative headboard. A touch of character for a romantic escape.",
        },
      ],
      cta: "Check availability",
    },
    gallery: {
      overline: "Gallery",
      title: "A glimpse of Annette Rooms",
      description: "The rooms, the bathrooms, the Palese sea. Click to enlarge.",
    },
    amenities: {
      overline: "Amenities",
      title: "Everything you need, nothing superfluous",
      items: [
        { title: "Free WiFi", desc: "Fast connection in every room." },
        { title: "Air Conditioning", desc: "Perfect climate, any season." },
        { title: "Private Bathroom", desc: "Shower, towels and toiletries included." },
        { title: "Flat-screen TV", desc: "In-room TV with national channels." },
        { title: "Non-smoking", desc: "Clean and healthy environment." },
        { title: "Private Check-in", desc: "We welcome you with keys in hand." },
        { title: "Minimarket", desc: "Essentials always within reach." },
        { title: "Private Entrance", desc: "Full discretion and autonomy." },
      ],
    },
    location: {
      overline: "Location",
      title: "A step from the sea, minutes from the airport",
      description:
        "Bari Palese is a quiet, authentic neighborhood — loved by those who seek the sea alongside the comfort of the city.",
      pins: [
        { label: "Bari Airport", value: "3 km" },
        { label: "Palese Beach", value: "13 min walk" },
        { label: "Metro Station", value: "3 min walk" },
        { label: "Bari City Center", value: "11 km" },
        { label: "Bari Cathedral", value: "11 km" },
        { label: "San Nicola Basilica", value: "11 km" },
      ],
      address: "Via Domenico Renna 14, Bari Palese, 70128 Bari, Italy",
      directions: "Get directions",
      openMap: "Open in Google Maps",
    },
    reviews: {
      overline: "Reviews",
      title: "In our guests' words",
      rating: "8.6 out of 10 — Excellent",
      count: "143 verified reviews",
      items: [
        {
          text: "Everything was perfect! The room was always clean and cozy to come back to after a long day. Location is great, 5 min to the beach and 3 min to the metro station.",
          author: "Kristina",
          country: "Germany",
        },
        {
          text: "Exceptionally clean B&B. Every day clean towels, mopped floors, even our things arranged. Very good location, close to train station and airport.",
          author: "Sylwia",
          country: "Poland",
        },
        {
          text: "New, clean, modern room, reasonable size and good bathroom. Excellent location for the airport and not far from the seafront with restaurants with a view.",
          author: "Ian",
          country: "United Kingdom",
        },
      ],
    },
    contact: {
      overline: "Get in touch",
      title: "Book your Apulian escape",
      description:
        "Message us directly on WhatsApp: we'll reply in real time with availability, rates, and every detail for your stay.",
      cta: "Open WhatsApp",
      phone: "Phone",
      email: "Email",
      address: "Address",
    },
    footer: {
      tagline: "B&B in the heart of Bari Palese",
      rights: "All rights reserved.",
      license: "License",
    },
  },
};
